import { Link } from "react-router-dom";
import type { Movie } from "@/types/cinema";

export default function HotRanking({ movies }: { movies: Movie[] }) {
  return (
    <div className="flex h-full flex-col rounded-lg border border-background-700/40 bg-primary-900 p-4 md:p-5">
      <div className="mb-4 flex items-center gap-2">
        <i className="ri-bar-chart-fill text-lg text-accent-500"></i>
        <h3 className="font-heading text-base font-semibold text-background-50">实时热门榜</h3>
      </div>
      <ul className="flex flex-1 flex-col gap-1">
        {movies.map((movie, index) => (
          <li key={movie.id}>
            <Link
              to={`/movie/${movie.id}`}
              className="flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-primary-800"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  index < 3 ? "bg-accent-500 text-background-50" : "bg-primary-800 text-primary-200"
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-background-50">
                  {movie.title}
                </span>
                <span className="block truncate text-xs text-primary-200">
                  {movie.genres[0]} · 热度 {movie.heat}
                </span>
              </span>
              <span className="shrink-0 text-xs font-semibold text-accent-400">
                {movie.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to="/movies"
        className="mt-3 flex items-center justify-center gap-1 rounded-md border border-primary-700 py-2 text-sm text-background-100 transition-colors hover:border-accent-500 hover:text-accent-400"
      >
        查看完整榜单
        <i className="ri-arrow-right-line"></i>
      </Link>
    </div>
  );
}